import React from 'react';
import { MdClose } from 'react-icons/md';
import Loader from "react-loader-spinner";

const Modal = ({t, title, type, jobTitle, jobData, showModal, loading, handleOk, handleCancel, footerOption1, footerOption2, handleModalClose, isFromworker}) => {
  
    let { /*DepartmentName, MasterProcessName, ProcessName,*/ JobId, customerInfo, formData } = populateFields(jobData, isFromworker);
    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleModalClose}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            {(type === 'cancel') ? <p>Are you sure cancel this job ?</p> : (type === 'complete') ? <p>Are you sure complete this job ?</p> : <div>
                                <p className="text-primary mb-2">{jobTitle}</p>
                                <div>
                                     {/* <p>Department: <span className="text-dark">{DepartmentName}</span></p>
                                     <p>Master Process: <span className="text-dark">{MasterProcessName}</span></p>
                                     <p>Service: <span className="text-dark">{ProcessName}</span></p> */}
                                     <p>Job Reference #: <span className="text-dark">{JobId}</span></p>
                                    {customerInfo && <p className="text-primary mb-1">{"Customer Info"}</p>}
                                    {customerInfo && Object.entries(customerInfo).map(([key, value]) =>
                                        <p key={key}>{key}: {value}</p>
                                    )}
                                    {jobData?.jobInfo && jobData?.jobInfo?.passportNo && <p className="">{"Customer Name"} : <span className="text-">{jobData?.jobInfo?.name}</span></p>}
                                    {jobData?.jobInfo && jobData?.jobInfo?.passportNo && <p className="mb-1">{"Passport No"} : <span className="text-">{jobData?.jobInfo?.passportNo}</span></p>}
                                    {formData.Data && <p className="text-primary mb-2">{"Job Info"}</p>}
                                    {formData.Data && Object.entries(formData.Data).map(([key, value]) =>
                                        <p key={key}>{key}: {value}</p>
                                    )}
                                    {/* <p className="text-dark mt-2">Document Data</p>
                                    {jobInfo && ((Object.entries(jobInfo.documents).length === 0) ? <p>No data available</p> : Object.entries(jobInfo.documents).map(([key, value]) =>
                                        <p key={key}>{key}: {value}</p>
                                    ))} */}
                                </div>
                            </div>}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" onClick={handleCancel}>{footerOption2 ? footerOption2 : t("sideNav.newJobRequest.close")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" onClick={() => handleOk('Accepted')}>{footerOption1 ? footerOption1 : t("sideNav.newJobRequest.ok")}
                                {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default Modal;

function populateFields(jobData, isFromworker) {
    let customerInfo = jobData.customerInfo;
    if (!isFromworker) {
        customerInfo = { Name: jobData.customerInfo };
    }
    let JobInfo = jobData.jobInfo;
    let formData = JSON.parse(JobInfo.json);
    let DepartmentName = JobInfo.departmentName;
    let MasterProcessName = JobInfo.masterProcessName;
    let ProcessName = JobInfo.processName;
    let JobId = JobInfo.jobId;
    return { DepartmentName, MasterProcessName, ProcessName, JobId, customerInfo, formData };
};